import React from 'react'
import SvgIcon from 'components/SvgIcon/SvgIcon'
import MyLink from 'components/MyLink'

// Recursive component to render menu items
const MenuItem = ({ item }) => {
  const hasChildren = item?.children && item?.children?.length > 0;
  
  if (!hasChildren) {
    return (
      <li className="menu-item" key={item?.id}>
        <MyLink to={item?.url} className="menu-link">{item?.text}</MyLink>
      </li>
    );
  }
  
  return (
    <li className="menu-item dropdown" key={item?.id}>
      <MyLink to={item?.url} className="menu-link">
        <span>{item?.text}</span>
        <SvgIcon name='wparrow' className='wparrow'/>
      </MyLink>
      <ul className="dropdown-menu">
        {item?.children?.map?.(child => {
          const hasNestedChildren = child?.children && child?.children?.length > 0;
          
          if (!hasNestedChildren) {
            return (
              <li className="dropdown-item" key={child?.id}>
                <MyLink to={child?.url}>{child?.text}</MyLink>
              </li>
            );
          }
          
          return (
            <li className="dropdown-item nested-dropdown" key={child?.id}>
              <MyLink to={child?.url} className="has-nested">
                {child?.text}
                <SvgIcon name='wparrow' className='wparrow-right'/>
              </MyLink>
              <ul className="nested-menu">
                {child?.children?.map?.(nestedChild => (
                  <li className="nested-item" key={nestedChild?.id}>
                    <MyLink to={nestedChild?.url}>{nestedChild?.text}</MyLink>
                  </li>
                ))}
              </ul>
            </li>
          );
        })}
      </ul>
    </li>
  );
};

export default MenuItem;